import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { AuthTokensDto, ObtainTokensRequestDto } from './auth.dto';

const obtainTokensPath = '/auth/obtain-tokens';
const refreshTokensPath = '/auth/refresh-tokens';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {
  private readonly http = inject(HttpClient);
  private readonly rawHttp = new HttpClient(inject(HttpBackend));
  private readonly baseUrl = environment.apiUrl;

  obtainTokens(payload: ObtainTokensRequestDto): Observable<AuthTokensDto> {
    return this.http.post<AuthTokensDto>(this.endpoint(obtainTokensPath), payload);
  }

  refreshTokens(refreshToken: string): Observable<AuthTokensDto> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${refreshToken}`,
    });

    return this.rawHttp.post<AuthTokensDto>(this.endpoint(refreshTokensPath), {}, { headers });
  }

  private endpoint(path: string): string {
    const baseUrl = this.baseUrl.replace(/\/+$/, '');
    const endpointPath = path.replace(/^\/+/, '');

    return `${baseUrl}/${endpointPath}`;
  }
}
